import { definePartner } from "../definePartner";

/**
 * Blue Tokai: an external loyalty partner (legacy class 2), a hybrid: the apply asks for an OTP like
 * Xeno's, but the VERIFY goes through the offer endpoint with a flat body and answers
 * `message: "success"`, so `requiresOtpOnApply` is Xeno's value while every verify field is the
 * baseline's.
 *
 * ⚠️ Its `referenceId` arrives on the VERIFY leg, not the apply. Reading it from the apply answer
 * (which carries none) stored `undefined` and left the release without an id.
 *
 * ⚠️ `offerCodeField: "couponCode"`: it mints a per-customer code per offer, and its `discountCode`
 * is the shared campaign id.
 *
 * ⚠️ `stampsExternalAuthentication: false`, for the same reason as Xeno.
 */
export default definePartner("bluetokai", {
  name: "Blue Tokai",
  backend: {
    listsOffers: true,
    appliesOffers: true,
    applyOtp: "skipped",
    takesTypedCodes: true,
    releaseNeeds: ["referenceId"],
    exercisedAtSave: false,
  },

  isExternalLoyalty: true,
  requiresCouponUnblock: true,

  offerCodeField: "couponCode",
  hasCouponModal: true,

  requiresOtpOnApply: true,
  sendsRequestId: true,

  stampsExternalAuthentication: false,
  referenceIdSource: "verify",
});
